import React, { FC } from "react";
import { Row, Card } from "antd";
import Helmet from "react-helmet";
import ForgotPasswordContainer from "../../../components/ForgotPassword";

const ForgotPassword: FC = () => {
  return (
    <Row justify="center">
      <Card>
        <Helmet title="Forgot Password" />
        <ForgotPasswordContainer />
      </Card>
    </Row>
  );
};

export default ForgotPassword;
